"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var types_1 = require("../types");
var ConsoleTransport = /** @class */ (function () {
    function ConsoleTransport() {
    }
    ConsoleTransport.prototype.send = function (sample) {
        var messageType = sample.type === types_1.ETelemetryType.COUNTER ? 'TELEMETRY.increment:' : 'TELEMETRY.timer:';
        // eslint-disable-next-line no-console
        console.log(messageType, sample.key, sample.value);
    };
    return ConsoleTransport;
}());
exports.ConsoleTransport = ConsoleTransport;
//# sourceMappingURL=console.js.map